<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
      <tr>
        <th class="text-left">Produto</th>
        <th>Quantidade</th>
        <template v-for="(prazo, idx) in prazos">
          <th :key="idx">
            <px-forma-pagamento :forma-pagamento="prazo.formaPagamento"
                                :prazo-pagamento="prazo.prazoPagamento"/>
          </th>
        </template>
        <th>ICMS</th>
        <th>IPI</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in resposta.produtos" :key="index">
        <td>
          {{ item.cotacaoConjuntaProduto.id }} -
          {{ item.cotacaoConjuntaProduto.produto.descricao }}
        </td>
        <td>
          <template v-if="!isRespondida(item)">
            <px-situacao-cotacao-produto-icon :situacao="item.situacao"/>
          </template>
          <template v-else>
            {{ item.cotacaoConjuntaProduto.quantidade }}
            {{ item.cotacaoConjuntaProduto.unidadeMedida.descricao }}
          </template>
        </td>
        <template v-for="(prazo, idx) in item.prazos">
          <td :key="idx">
            <template v-if="isRespondida(item)">
              <span v-if="isPrazoRespondido(prazo)">
                {{ prazo.precoUnitario | currency }}
              </span>
              <span v-else>
                -
              </span>
            </template>
          </td>
        </template>
        <td>
          <px-imposto-simple v-if="isRespondida(item)" :imposto="item.impostos" tipo="ICMS"/>
        </td>
        <td>
          <px-imposto-simple v-if="isRespondida(item)" :imposto="item.impostos" tipo="IPI"/>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { first } from 'lodash';
import { SituacaoRespostaCotacaoProduto, SituacaoRespostaPrazo } from 'px-business-components';

export default {
  props: {
    resposta: Object,
  },
  computed: {
    prazos() {
      return first(this.resposta.produtos).prazos;
    },
    isRespondida() {
      return (item) => item.situacao === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    isPrazoRespondido() {
      return (item) => item.situacao === SituacaoRespostaPrazo.keys.RESPONDIDA.key;
    },
  },
};
</script>
